import { useState as u, useEffect as o } from "react";
let r = 0;
const s = () => ++r,
  l = e => {
    const [t, n] = u(null);
    return o(() => {
      t === null && n(s());
    }, [t]), "".concat(e, "-").concat(t);
  };
export { l as useUniqueId };